import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { incrementPostLikeCount } from '../../actions/increment-post-like-count';
import { incrementCommentLikeCount } from '../../actions/increment-comment-like-count';
import SearchResultsList from '../../components/search-results-list';

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      onPostLikeClick: incrementPostLikeCount,
      onCommentLikeClick: incrementCommentLikeCount,
    },
    dispatch,
  );

export default connect(
  undefined,
  mapDispatchToProps,
)(SearchResultsList);
